module.exports = __webpack_public_path__ + "img/plus-big.04ab56d0.svg";